import firebase from 'firebase';

var firebaseConfig = {
    apiKey: "AIzaSyD37bdftWk5MKgOQ0JEuqDtcnRmVls0bh0",
    authDomain: "kamin-soroka-project.firebaseapp.com",
    databaseURL: "https://kamin-soroka-project.firebaseio.com",
    projectId: "kamin-soroka-project",
    storageBucket: "kamin-soroka-project.appspot.com",
    messagingSenderId: "329788359125",
    appId: "1:329788359125:web:05fb3d1fb612de63aa7d5c",
    measurementId: "G-LGTZ17LDTN"
};
// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);

export default fire;